import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=bbff5b80&"
import script from "./TicketItem.vue?vue&type=script&lang=js&"
export * from "./TicketItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports